import { render } from "./PasivoCortoPlazoComponent.vue?vue&type=template&id=794529eb&scoped=true"
import script from "./PasivoCortoPlazoComponent.vue?vue&type=script&lang=js"
export * from "./PasivoCortoPlazoComponent.vue?vue&type=script&lang=js"

import "./PasivoCortoPlazoComponent.vue?vue&type=style&index=0&id=794529eb&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794529eb"]])

export default __exports__